import { selectBasketDeliveries, selectBasketList } from 'containers/OrderDetails/basketSlice'
import useTranslation from 'hooks/useTranslation'
import { useReduxSelector } from 'store'
import React, { Fragment } from 'react'

const DeliveryItem: React.FC = () => {
  const deliveries = useReduxSelector(selectBasketDeliveries)
  const list = useReduxSelector(selectBasketList)
  const { t } = useTranslation('basket')

  const data = (deliveries as basic.Form[])?.reduce((r, delivery) => {
    const productWithDelivery = (list as basic.Form[]).filter(l => l.deliveryId === delivery.id)
    if (productWithDelivery.length > 0) {
      r.push({
        id: delivery.id,
        name: t(delivery.type),
        desc: delivery.pointId
          ? `${delivery.pointId}${delivery.lockerId ? `, ${t('locker')} ${delivery.lockerId}` : ''}`
          : delivery.address
            ? `${delivery.address.street} ${delivery.address.estateNumber}${delivery.address.localNumber ? `/${delivery.address.localNumber}` : ''}, ${delivery.address.zip} ${delivery.address.city}`
            : undefined,
        products: productWithDelivery
      })
    }
    return r
  }, [])

  if (!data || data.length === 0) {
    return null
  }

  return (
    <div className='basketPopup__list__item'>
      <div className='basketPopup__list__item__block'>
        {/* <div className='basketPopup__list__item__row'>
          <span className='--title'>{t('delivery')}</span>
        </div> */}
        {(data as basic.Form[]).map(({ id, name, desc, products }) => <Fragment key={id}>
          <div className='basketPopup__list__item__row'>{name}{desc ? ` - ${desc}` : ''}:
          </div>
          {(products as basic.Form[]).map(({ name }, idx) => <div
            key={idx}
            className='basketPopup__list__item__row'>
            <span>- {name}</span>
          </div>)}
        </Fragment>)}
      </div>
    </div>
  )
}

export default DeliveryItem